<script>
import LoginInput from "./LoginInput.vue";
import Btn from "./Btn.vue";
import ForgotPwdDialog from "./ForgotPwdDialog.vue";
export default {
  components: {
    LoginInput,
    Btn,
    ForgotPwdDialog
  },
  props: {
    username: {},
    password: {},
    forPlayer: Boolean,
    platformName: String,
    newForgetPwd: Boolean,
    isLoginRemember: Boolean,
    isElectron: {}
  },
  data() {
    return {
      showForgotPwdDialog: false,
      isRemember: false
    };
  },
  created() {
    this.isRemember = this.isLoginRemember;
  },
  computed: {
    title() {
      if (this.platformName) {
        return this.platformName;
      } else {
        return this.forPlayer ? "视感知觉训练软件" : "视感知觉训练软件后台管理";
      }
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    onClickForgetPwd() {
      this.$emit("onClickForgetPwd");
    },
    handleChangeRememberPassword() {
      this.$emit("changeRememberPassword", this.isRemember);
    }
  }
};
</script>

<template>
  <div class="TheLogin">
    <ForgotPwdDialog v-if="showForgotPwdDialog" @confirm="showForgotPwdDialog = false" />
    <div class="loginContainer">
      <div class="center">
        <img class="logo" src="./assets/login_logo.svg" />
        <div class="titleContainer">
          <h1>{{title}}</h1>
        </div>
        <LoginInput
          type="username"
          autocomplete="off"
          :value="username"
          @input="$emit('update:username', $event)"
          @keyup.enter.native="confirm"
        />
        <LoginInput
          type="password"
          autocomplete="off"
          :value="password"
          @input="$emit('update:password', $event)"
          @keyup.enter.native="confirm"
        />
        <div class="text_box" v-if="isElectron">
          <el-checkbox
            class="remember_password"
            v-model="isRemember"
            @change="handleChangeRememberPassword"
          >记住密码</el-checkbox>
          <p @click="onClickForgetPwd" class="forgotPwdElectron">忘记密码？</p>
        </div>

        <p v-else @click="onClickForgetPwd" class="forgotPwd">忘记密码？</p>

        <Btn @click="confirm">登录</Btn>
      </div>
    </div>
    <p>珠海广目锐视医疗科技有限公司</p>
  </div>
</template>

<style lang="scss" scoped>
@import "./css/color.scss";
.TheLogin {
  height: 100vh;
  max-width: 1350px;
  min-width: 1024px;
  margin-left: auto;
  margin-right: auto;
  background-repeat: no-repeat;
  background-image: url("./assets/login_bg_lt.svg"),
    url("./assets/login_bg_rt.svg"), url("./assets/login_bg_lb.svg"),
    url("./assets/login_bg_rb.svg");
  background-position: 0px 22px, right 6px top 52px, left bottom 90px,
    right bottom 100px;
  align-items: center;
  .loginContainer {
    height: calc(100vh - 51px);
    width: 240px;
    margin: 0px auto;
    text-align: center;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .logo {
      margin-bottom: 21px;
      width: 70px;
      height: 83px;
    }
    .titleContainer {
      height: 39px;
      margin-bottom: 59px;
      > h1 {
        color: #00c1de;
        font-size: 18px;
      }
    }
    .LoginInput {
      margin-bottom: 13px;
    }
    .text_box {
      display: flex;
      justify-content: space-between;
      width: 240px;
    }
    .forgotPwd {
      font-size: 14px;
      text-align: right;
      width: 239px + 18px;
      color: #00c1de;
      height: 0px;
      cursor: pointer;
    }
    .forgotPwdElectron {
      font-size: 14px;
      text-align: right;
      color: #00c1de;
      height: 0px;
      cursor: pointer;
    }
    .remember_password {
    }
    .Btn {
      margin-top: 79px - 13px;
      width: 239px;
      height: 39px;
      font-size: 14px;
    }
  }
  > p {
    margin-bottom: 35px;
    color: #b9b9b9;
    font-size: 12px;
    height: 16px;
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// yotta-vue-components/vision/Login.vue